module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.b233546e.woff";